import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/widgets/automatedNarrative/components/narrativeOf/NarrativeOf.module.scss';

interface Props {
    title: string | undefined;
}

export const NarrativeOf = ({ title }: Props) => {
    return (
        <div className={classes.narrativeOf}>
            <MuiIcon icon={'auto_awesome_icon'} color={'#3183fe'} />
            <span className={classes.narrativeOfText}>AI Narrative for:</span>
            <span className={classes.value}>{title}</span>
        </div>
    );
};
